/* eslint-disable react/no-danger */
/* eslint-disable react/button-has-type */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState, useRef } from 'react';
import {
  LuBedDouble,
  LuShieldCheck,
  // LuGlobe2,
  LuBus,
  LuPlane,
  LuTrain,
} from 'react-icons/lu';
import { GiCruiser } from 'react-icons/gi';
import { LiaCarSolid } from 'react-icons/lia';
import { Carousel } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import './LandingPage.scss';
import { FaPassport, FaUmbrellaBeach, FaWpforms } from 'react-icons/fa';

import {
  hideHeaderFooterInMobile,
  hideHeaderOptions,
  isEmpty,
  isMobileWidth,
  showHeaderFooterInMobile,
  showHeaderOptions,
} from '../../shared/helper-utils/appUtils';

import FlightLandingPage from '../flights/FlightLandingPage';
import BusLandingPage from '../buses/bus-search/BusLandingPage';
import AppModal from '../../shared/components/app-modal/AppModal';
import {
  getStringFromLS,
  getUserAgentId,
  getValueFromAppConfig,
  setStringInLs,
} from '../../shared/helper-utils/localStorage';
import {
  getBannerImagesForLogin,
  getMessageFromAdmin,
} from '../../api/profileApi';
import AppHeader from '../../shared/components/app-header/AppHeader';
import HotelLandingPageV2 from '../hotels/hotel-search/HotelLandingPageV2';
import CruiseComponent from '../cruise/cruise-landingpage/CruiseLanding';
import CabsSearch from '../cabs/landing/CabsSearch';
import { useAppContext } from '../../saas/AppConfigWrapper';
import { APP_ADMIN_MESSAGE } from '../../saas/AppStorageStaticNames';
import AppButton from '../../shared/components/app-button/AppButton';
import AppLink from '../../shared/components/app-link/AppLink';
// import TrainLandingPage from '../trains/train-search/TrainLandingPage';

const FLIGHT = 'flight';
const HOTEL = 'hotel';
const BUS = 'bus';
const TRAIN = 'train';
const INSURANCE = 'insurance';
const PACKAGES = 'packages';
const CRUISE = 'cruise';
const CABS = 'cabs';
const VISA = 'visa';
const ESIM = 'esim';
const HOLIDAY_PACKAGE = 'holidaypackage';
const HONEYMOON_PACKAGE = 'honeymoonpackage';
const TOUR_PACKAGE = 'tourpackage';
const ZINDAGI_DOBARA = 'zindagidobara';
const ONLINE_VISA = 'onlinevisa';
const ETCTAB = 'etctab';
const TOP_DEALS = 'topdeals';

function LandingPage() {
  const { appConfig } = useAppContext();
  const location = useLocation();
  const navigate = useNavigate();
  const activityDropdownRef = useRef(null);
  const [selectedTab, setSelectedTab] = useState(FLIGHT);
  const [showSalesRepDetails, setShowSalesRepDetails] = useState(false);
  const [bannerImages, setBannerImages] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const handleCruiseClick = () => setIsDropdownOpen(true);
  const [adminMessages, setAdminMessages] = useState([]);
  const [showAdminMessagePopup, setShowAdminMessagePopup] = useState(false);
  const isChecked = getStringFromLS(APP_ADMIN_MESSAGE);
  const [selectedAdminMessageIndex, setSelectedAdminMessageIndex] = useState(0);

  useEffect(() => {
    const searchType = new URLSearchParams(location.search).get('searchtype');
    const agentId = getUserAgentId();
    setSelectedTab(searchType || FLIGHT);
  }, [location]);

  const handleOnTabSelect = (tab) => {
    if (selectedTab !== tab) {
      setSelectedTab(tab);
      const searchParams = new URLSearchParams(location.search);
      searchParams.set('searchtype', tab);
      const newURL = `${location.pathname}?${searchParams.toString()}`;
      window.history.pushState({ path: newURL }, '', newURL);
    }
  };

  useEffect(() => {
    const agentId = getUserAgentId();
    // hideHeaderOptions();
    // return () => showHeaderOptions();
  }, []);

  const getBannerImages = async () => {
    const response = await getBannerImagesForLogin();
    if (response && response.Root && response.Root.Status === 'OK') {
      const imageValuts = response.Root.Result?.LoginImageVaults;
      if (!isEmpty(imageValuts)) {
        let list = imageValuts?.LoginImageVault;
        list = Array.isArray(list) ? list : [list];
        setBannerImages(list);
      }
    }
  };

  useEffect(() => {
    getBannerImages();
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth',
    });
  }, []);
  useEffect(() => {
    hideHeaderFooterInMobile();
    return () => showHeaderFooterInMobile();
  }, []);
  const handleShowPrevMsg = () => {
    let index = selectedAdminMessageIndex;
    if (index === 0) {
      return;
    }
    if (index > 0) {
      index -= 1;
      setSelectedAdminMessageIndex(index);
    }
  };
  const handleShowNextMsg = () => {
    let index = selectedAdminMessageIndex;
    if (index === adminMessages.length - 1) {
      return;
    }
    if (index < adminMessages.length) {
      index += 1;
      setSelectedAdminMessageIndex(index);
    }
  };
  const handleGetAdminMessages = async () => {
    if (isChecked === undefined || isChecked === null || isChecked === false) {
      const res = await getMessageFromAdmin();
      if (res && res.Root && res.Root.Status === 'OK') {
        const { AdminMessage } = res.Root.Result;
        const list = Array.isArray(AdminMessage)
          ? AdminMessage
          : [AdminMessage];
        setAdminMessages(list);
        setShowAdminMessagePopup(true);
      }
    }
  };
  useEffect(() => {
    handleGetAdminMessages();
  }, []);

  const handleCloseAdminMessagesPopup = () => {
    setStringInLs(APP_ADMIN_MESSAGE, true);
    setShowAdminMessagePopup(false);
  };

  const handleNavigateToService = (service) => {
    try {
      let link;
      const servicesLinks = getValueFromAppConfig('SAAS_APP_SERVICES_LINK')
        .split(',')
        .reduce((acc, cur) => {
          acc.push({
            service: cur.split('@@@')[0],
            link: cur.split('@@@')[1],
          });
          return acc;
        }, []);
      const portfolioService = servicesLinks.find((x) => x.service === service);
      if (portfolioService) {
        link = portfolioService.link;
      } else {
        link = '';
      }
      const element = document.createElement('a');
      element.href = link;
      element.target = '_blank';
      element.click();
    } catch (error) {
      //
    }
  };

  const handleNavigateToEsim = () => {
    navigate('/esim');
  };

  return (
    <div>
      {isMobileWidth() && <AppHeader />}
      <div className="landing-page mb-4">
        <div className="landing-page_search">
          <div className="py-sm-5 py-3">
            <div className="landing-page_search_container d-flex flex-column align-items-center mt-sm-5 mt-3">
              <div className="landing-page_search_container_header">
                {appConfig.hasFlight && (
                  <div
                    className={`service-tab ${
                      selectedTab === FLIGHT ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => handleOnTabSelect(FLIGHT)}
                  >
                    <LuPlane />
                    <span>Flight</span>
                  </div>
                )}
                {appConfig.hasHotel && (
                  <div
                    className={`service-tab ${
                      selectedTab === HOTEL ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => handleOnTabSelect(HOTEL)}
                  >
                    <LuBedDouble />
                    <span>Hotel</span>
                  </div>
                )}
                {appConfig.hasPackage && (
                  <div
                    className={`service-tab ${
                      selectedTab === PACKAGES ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => setSelectedTab(PACKAGES)}
                  >
                    <FaUmbrellaBeach />
                    <span>Packages</span>
                  </div>
                )}
                {appConfig.hasCruise && (
                  <div
                    className={`service-tab ${
                      selectedTab === CRUISE ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => handleOnTabSelect(CRUISE)}
                  >
                    <GiCruiser />
                    <span>Cruises</span>
                  </div>
                )}
                {appConfig.hasCab && (
                  <div
                    className={`service-tab ${
                      selectedTab === CABS ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => handleOnTabSelect(CABS)}
                  >
                    <LiaCarSolid />
                    <span>Transfers</span>
                  </div>
                )}
                {appConfig.hasBus && (
                  <div
                    className={`service-tab ${
                      selectedTab === BUS ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => handleOnTabSelect(BUS)}
                  >
                    <LuBus />
                    <span>Bus</span>
                  </div>
                )}
                {appConfig.hasTrain && (
                  <div
                    className={`service-tab ${
                      selectedTab === TRAIN ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => handleOnTabSelect(TRAIN)}
                  >
                    <LuTrain />
                    <span>Rail</span>
                  </div>
                )}
                {appConfig.hasInsurance && (
                  <div
                    className={`service-tab ${
                      selectedTab === INSURANCE ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => navigate('/insurance')}
                  >
                    <LuShieldCheck />
                    <span>Insurance</span>
                  </div>
                )}
                {appConfig.hasVisa && (
                  <div
                    className={`service-tab ${
                      selectedTab === VISA ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => navigate('/visa')}
                  >
                    <FaPassport />
                    <span>Visa</span>
                  </div>
                )}
                {appConfig.hasVisaForm &&
                  String(getValueFromAppConfig('OUTESIM')).toLowerCase() !==
                    'true' && (
                    <div
                      className={`service-tab ${
                        selectedTab === VISA ? 'selected-service-tab' : ''
                      }`}
                      onClick={() => handleNavigateToService('visaform')}
                    >
                      <img
                        src="/images/others/visa.svg"
                        alt=""
                        width="30px"
                        height="30px"
                      />
                      <span>Visa</span>
                    </div>
                  )}
                {appConfig.hasOnlineVisa && (
                  <div
                    className={`service-tab ${
                      selectedTab === ONLINE_VISA ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => navigate('/online-visa')}
                  >
                    <img
                      src="/images/others/visa.svg"
                      alt=""
                      width="30px"
                      height="30px"
                    />
                    <span>Visa</span>
                  </div>
                )}
                {appConfig.hasEsim && (
                  <div
                    className={`service-tab ${
                      selectedTab === ESIM ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => handleNavigateToService(ESIM)}
                  >
                    <img
                      src="/images/others/Esim.svg"
                      alt=""
                      width="30px"
                      height="30px"
                    />
                    <span>E Sim</span>
                  </div>
                )}
                {appConfig.hasEsimfast && (
                  <div
                    className={`service-tab ${
                      selectedTab === ESIM ? 'selected-service-tab' : ''
                    }`}
                    onClick={handleNavigateToEsim}
                  >
                    <img
                      src="/images/others/Esim.svg"
                      alt=""
                      width="30px"
                      height="30px"
                    />
                    <span>E-Sim</span>
                  </div>
                )}
                {(getValueFromAppConfig('OUTESIM') === true ||
                  String(getValueFromAppConfig('OUTESIM')).toLowerCase() ===
                    'true') && (
                  <>
                    <div
                      className={`service-tab ${
                        selectedTab === ESIM ? 'selected-service-tab' : ''
                      }`}
                      onClick={() =>
                        window.open('https://esim.connectedyou.io/', '_blank')
                      }
                    >
                      <img
                        src="/images/others/Esim.svg"
                        alt=""
                        width="30px"
                        height="30px"
                      />
                      <span>E-Sim</span>
                    </div>
                    <div
                      className={`service-tab ${
                        selectedTab === VISA ? 'selected-service-tab' : ''
                      }`}
                      onClick={() =>
                        window.open('https://www.vizova.ai/', '_blank')
                      }
                    >
                      <img
                        src="/images/others/visa.svg"
                        alt=""
                        width="30px"
                        height="30px"
                      />
                      <span>Visa</span>
                    </div>
                  </>
                )}
                {appConfig.hasTourPackages && (
                  <div
                    className={`service-tab ${
                      selectedTab === TOUR_PACKAGE ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => handleNavigateToService(TOUR_PACKAGE)}
                  >
                    <img
                      src="/images/others/tour_package.svg"
                      alt=""
                      width="30px"
                      height="30px"
                    />
                    <span>Tour</span>
                    <span>Package</span>
                  </div>
                )}
                {appConfig.hasHoneymoonPackages && (
                  <div
                    className={`service-tab ${
                      selectedTab === HONEYMOON_PACKAGE
                        ? 'selected-service-tab'
                        : ''
                    }`}
                    onClick={() => handleNavigateToService(HONEYMOON_PACKAGE)}
                  >
                    <img
                      src="/images/others/Honeymoon.svg"
                      alt=""
                      width="30px"
                      height="30px"
                    />
                    <span>Honeymoon</span>
                    <span>Package</span>
                  </div>
                )}
                {appConfig.hasHoneymoonPackages && (
                  <div
                    className={`service-tab ${
                      selectedTab === ZINDAGI_DOBARA
                        ? 'selected-service-tab'
                        : ''
                    }`}
                    onClick={() => handleNavigateToService(ZINDAGI_DOBARA)}
                  >
                    <img
                      src="/images/others/jindgi_dobara.svg"
                      alt=""
                      width="30px"
                      height="30px"
                    />
                    <span>Zindagi</span>
                    <span>Dobara</span>
                  </div>
                )}
                {appConfig.hasEtcForm && (
                  <div
                    className={`service-tab ${
                      selectedTab === ETCTAB ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => navigate('/contact-us?scrollToForm=true')}
                  >
                    <FaWpforms />
                    <span>Etc</span>
                  </div>
                )}
                {appConfig.hasTopDeals && (
                  <div
                    className={`service-tab ${
                      selectedTab === TOP_DEALS ? 'selected-service-tab' : ''
                    }`}
                    onClick={() => handleNavigateToService(TOP_DEALS)}
                  >
                    <img
                      src="/images/others/top_deals.svg"
                      alt=""
                      width="30px"
                      height="30px"
                    />
                    <span>Top</span>
                    <span>Deals</span>
                  </div>
                )}
              </div>
              <div className="landing-page_search_container_search">
                {appConfig.hasFlight && selectedTab === FLIGHT && (
                  <FlightLandingPage />
                )}
                {appConfig.hasHotel && selectedTab === HOTEL && (
                  <HotelLandingPageV2 />
                )}
                {appConfig.hasBus && selectedTab === BUS && <BusLandingPage />}
                {appConfig.hasCruise && selectedTab === CRUISE && (
                  <CruiseComponent
                    selectedTab={selectedTab}
                    onTabSelect={handleOnTabSelect}
                  />
                )}
                {appConfig.hasCab && selectedTab === CABS && <CabsSearch />}
                {appConfig.hasTrain && selectedTab === TRAIN && (
                  <div className="p-3 text-center">
                    <p>Coming Soon ...</p>
                  </div>
                )}
                {appConfig.hasInsurance && selectedTab === INSURANCE && (
                  <div className="p-3 text-center">
                    <p>Coming Soon ...</p>
                  </div>
                )}
                {appConfig.hasPackage && selectedTab === PACKAGES && (
                  <div className="p-3 text-center">
                    <p>Coming Soon ...</p>
                  </div>
                )}
              </div>
            </div>
            {selectedTab === FLIGHT && <div id="flight-recent-searches-root" />}
          </div>
        </div>
        {appConfig.hasBannerImageslanding === 'true' &&
          bannerImages.length > 0 && (
            <div className="landing-page_banner">
              <div className="landing-page_banner_container">
                <Carousel className="details-page-carousal">
                  {bannerImages.map((d, index) => (
                    <Carousel.Item
                      key={index}
                      // style={{ backgroundImage: `url('${d}')` }}
                    >
                      <img
                        src={d.ImageAlt}
                        alt=""
                        className="details-page-carousal_image"
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </div>
          )}
        {/* <div className="landing-page_offers pb-5 pt-3">
        <div className="landing-page_offers_container">
          <div className="landing-page_offers_container_header">
            <div className="fs-5 fw-500">Offers</div>
            <div className="d-flex gap-2">
              <div className="landing-page_offers_container_header_active-btn">
                <span>All offers</span>
              </div>
              <div className="landing-page_offers_container_header-btn">
                <span>Flights</span>
              </div>
              <div className="landing-page_offers_container_header-btn">
                <span>Hotels</span>
              </div>
            </div>
          </div>
          <div className="landing-page_offers_container_content">
            <div className="row mt-1">
              <div className="col-md-6 col-12 ">
                <div className="landing-page_offers_container_content_card d-flex gap-md-4 gap-2 flex-column flex-sm-row">
                  <div className="landing-page_offers_container_content_image">
                    <img src="/images/others/jasyatra-offers-img.jpeg" alt="" />
                  </div>
                  <div className="landing-page_offers_container_content_description d-flex flex-column gap-2 p-2">
                    <span className="fs-12">INTL FLIGHTS</span>
                    <span className="fs-14 fw-600">
                      LIVE NOW: Sale by vistara
                    </span>
                    <span className="fs-12 grey-color">
                      Round-trip flights connecting Mumbai & Mauritius start @
                      ₹54,600*....
                    </span>
                    <div className="landing-page_offers_container_content_action-btn">
                      <span>Know more</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12 ">
                <div className="landing-page_offers_container_content_card d-flex gap-md-4 gap-2 flex-column flex-sm-row">
                  <div className="landing-page_offers_container_content_image">
                    <img
                      src="/images/others/jasyatra-offers-img.jpeg
                  "
                      alt=""
                    />
                  </div>
                  <div className="landing-page_offers_container_content_description d-flex flex-column gap-2 p-2">
                    <span className="fs-12">INTL FLIGHTS</span>
                    <span className="fs-14 fw-600">
                      LIVE NOW: Sale by vistara
                    </span>
                    <span className="fs-12 grey-color">
                      Round-trip flights connecting Mumbai & Mauritius start @
                      ₹54,600*....
                    </span>
                    <div className="landing-page_offers_container_content_action-btn">
                      <span>Know more</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-6 col-12 ">
                <div className="landing-page_offers_container_content_card d-flex gap-md-4 gap-2 flex-column flex-sm-row">
                  <div className="landing-page_offers_container_content_image">
                    <img
                      src="/images/others/jasyatra-offers-img.jpeg
                  "
                      alt=""
                    />
                  </div>
                  <div className="landing-page_offers_container_content_description d-flex flex-column gap-2 p-2">
                    <span className="fs-12">INTL FLIGHTS</span>
                    <span className="fs-14 fw-600">
                      LIVE NOW: Sale by vistara
                    </span>
                    <span className="fs-12 grey-color">
                      Round-trip flights connecting Mumbai & Mauritius start @
                      ₹54,600*....
                    </span>
                    <div className="landing-page_offers_container_content_action-btn">
                      <span>Know more</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12 ">
                <div className="landing-page_offers_container_content_card d-flex gap-md-4 gap-2 flex-column flex-sm-row">
                  <div className="landing-page_offers_container_content_image">
                    <img
                      src="/images/others/jasyatra-offers-img.jpeg
                  "
                      alt=""
                    />
                  </div>
                  <div className="landing-page_offers_container_content_description d-flex flex-column gap-2 p-2">
                    <span className="fs-12">INTL FLIGHTS</span>
                    <span className="fs-14 fw-600">
                      LIVE NOW: Sale by vistara
                    </span>
                    <span className="fs-12 grey-color">
                      Round-trip flights connecting Mumbai & Mauritius start @
                      ₹54,600*....
                    </span>
                    <div className="landing-page_offers_container_content_action-btn">
                      <span>Know more</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
        {showSalesRepDetails && (
          <AppModal
            modalTitle="Support Details"
            showFooter={false}
            showCloseButton
            className="sales-rep-details fs-14"
            onModalClose={() => setShowSalesRepDetails(false)}
            backdrop="renderbackdrop"
          >
            <section>
              <div className="d-flex flex-column mb-2 p-3">
                {/* <span>
                Name: <span className="fs-14 fw-600">Prakash</span>
              </span>
              <span>
                Email: <span className="fs-14 fw-600"> jasyatra@gmail.com</span>
              </span>
              <span>
                Phone No: <span className="fs-14 fw-600">9977973666</span>
              </span> */}
              </div>
            </section>
          </AppModal>
        )}
      </div>
      {showAdminMessagePopup &&
        adminMessages.length > 0 &&
        isChecked === null && (
          <AppModal
            modalTitle="Message From Admin"
            showCloseButton={false}
            onModalClose={handleCloseAdminMessagesPopup}
          >
            {adminMessages.length > 0 ? (
              <div className="d-flex flex-column align-items-center fs-14">
                <div className="d-flex justify-content-between align-items-center w-100 fw-500 ">
                  <AppLink
                    variant="secondary"
                    linkText={
                      selectedAdminMessageIndex === 0 ? '' : 'Prev Message'
                    }
                    onClick={handleShowPrevMsg}
                  />
                  <AppLink
                    variant="secondary"
                    linkText={
                      selectedAdminMessageIndex === adminMessages.length - 1
                        ? ''
                        : 'Next Message'
                    }
                    onClick={handleShowNextMsg}
                  />
                </div>
                <div> </div>
                <p className="fw-600 mb-1">
                  {adminMessages[selectedAdminMessageIndex]?.MessageTitle}
                </p>
                {adminMessages[selectedAdminMessageIndex]
                  ?.MessageDescription && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        adminMessages[selectedAdminMessageIndex]
                          ?.MessageDescription,
                    }}
                  />
                )}
              </div>
            ) : (
              <div className="fs-14 fw-500 text-center">
                No Messages From Admin
              </div>
            )}
            <div className="d-flex justify-content-end">
              <AppButton
                btnText="Close"
                // variant="outlined"
                onClick={handleCloseAdminMessagesPopup}
              />
            </div>
          </AppModal>
        )}
    </div>
  );
}

export default LandingPage;
